var map = {
	"./Close.svg": "df88",
	"./HTCopy.svg": "e12e",
	"./HTPaste-white.svg": "1513",
	"./HTPaste.svg": "5117",
	"./IES5.svg": "f019",
	"./ImgToolBox.svg": "7caf",
	"./Piechart.svg": "e822",
	"./Ques.svg": "28d1",
	"./SetAns.svg": "0307",
	"./SetAnsEn.svg": "fed7",
	"./Text-icons.svg": "7d0b",
	"./add_arrow.svg": "15a8",
	"./add_arrow2.svg": "de69",
	"./add_img.svg": "1100",
	"./add_pdf.svg": "b44f",
	"./add_ppt.svg": "74f3",
	"./arrow-down.svg": "f66a",
	"./arrow-top.svg": "ad83",
	"./attachment.svg": "4eba",
	"./barchart.svg": "52b2",
	"./buzz-new.svg": "637a",
	"./buzzin.svg": "f7e9",
	"./check.svg": "a7c0",
	"./choose-student.svg": "ee94",
	"./close-bold.svg": "7fae",
	"./collate.svg": "19e5",
	"./continue.svg": "f6ce",
	"./copy.svg": "c0a5",
	"./copyToClipboard.svg": "f119",
	"./copyToClipboardLight.svg": "8554",
	"./default-doc.svg": "6b47",
	"./download.svg": "039a",
	"./empty-data.svg": "3d41",
	"./exitfullscreen.svg": "55fb",
	"./eye-hide white.svg": "f798",
	"./eye-hide.svg": "8e03",
	"./eye-show.svg": "195a",
	"./flop.svg": "aa86",
	"./full-screen.svg": "6d88",
	"./grid.svg": "a8cb",
	"./hi.svg": "b40f",
	"./hideIRSArrow.svg": "3e10",
	"./htc_cc.svg": "d2c7",
	"./img_upload.svg": "8838",
	"./interactions.svg": "94fe",
	"./interactive.svg": "5a4c",
	"./irs-icon.svg": "9d58",
	"./irs-text.svg": "a814",
	"./irs.svg": "eb96",
	"./lang_cn.svg": "871a",
	"./lang_cn_sel.svg": "8879",
	"./lang_en.svg": "46d3",
	"./lang_en_sel.svg": "e86af",
	"./lang_tw.svg": "0729",
	"./lang_tw_sel.svg": "1b0b",
	"./log_out.svg": "9ebe",
	"./memberlist.svg": "ebe1",
	"./message.svg": "15e8",
	"./new-file.svg": "43b4",
	"./new-page.svg": "2a36",
	"./next.svg": "8def",
	"./nextImgBtn.svg": "6add",
	"./no-color.svg": "0cfd",
	"./open-file.svg": "adba",
	"./play.svg": "4c1a",
	"./prev.svg": "54ca",
	"./previous.svg": "944c",
	"./previusImgBtn.svg": "087c",
	"./pushImg.svg": "ede9",
	"./pw_enter.svg": "6fec",
	"./pw_invisibility.svg": "6948",
	"./pw_visibility.svg": "4ebac",
	"./qrcode.svg": "8c7c",
	"./question.svg": "5d9e",
	"./rank.svg": "ecb9",
	"./refresh.svg": "b41b",
	"./screen-note.svg": "4e20",
	"./screenshot.svg": "1fb3",
	"./select.svg": "0ee3",
	"./setAnsNew.svg": "11c0",
	"./shap.svg": "b2c7",
	"./sortNum.svg": "390c",
	"./star.svg": "4e5a",
	"./stop.svg": "f12f",
	"./students.svg": "a5e7",
	"./switchover.svg": "8ae5",
	"./text.svg": "4f9e",
	"./timer.svg": "e7f9",
	"./trash-alt-solid.svg": "8469",
	"./trash.svg": "53bd",
	"./undo.svg": "18d6",
	"./word-cloud.svg": "b560",
	"./zoom.svg": "d534"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";